import { render, staticRenderFns } from "./File_add_consultation.vue?vue&type=template&id=63e497da&style=height%3A%20100%25%3B"
import script from "./File_add_consultation.vue?vue&type=script&lang=js"
export * from "./File_add_consultation.vue?vue&type=script&lang=js"
import style0 from "./File_add_consultation.vue?vue&type=style&index=0&id=63e497da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports